export const useCookieYesStore = defineStore('cookieYesStore', () => {
  /* State */

  const isCookieYesConsent = ref<boolean>(false);
  const isCookieYesCompleted = ref<boolean>(false);

  /* Actions */

  const HANDLE_COOKIE_YES_LOAD = (eventData: any): void => {
    /**
     * CookieYes 載入完成
     */
    const data = eventData.detail;
    console.log('cookieyes_banner_load', eventData);
    if (data && data.categories) {
      // NOTE: advertisement 有同意才算通過
      if (data.categories.advertisement === true) {
        isCookieYesConsent.value = true;
      }
    }
    isCookieYesCompleted.value = true;
  };

  const HANDLE_COOKIE_YES_UPDATE = (eventData: any): void => {
    /**
     * CookieYes 狀態更新
     */
    const data = eventData.detail;
    console.log('cookieyes_consent_update', eventData);
    if (data && data.accepted) {
      // NOTE: advertisement 有同意才算通過
      if (data.accepted.includes('advertisement')) {
        isCookieYesConsent.value = true;
      }
    }
    isCookieYesCompleted.value = true;
  };

  const SET_COOKIE_YES_COMPLETE = (): NodeJS.Timeout | null => {
    if (isCookieYesCompleted.value === true) {
      return null;
    }

    return setTimeout(() => {
      if (typeof window.getCkyConsent === 'function') {
        const consent = window.getCkyConsent();
        console.log('getCkyConsent', consent);
        if (consent && consent.categories) {
          // NOTE: advertisement 有同意才算通過
          if (consent.categories.advertisement === true) {
            isCookieYesConsent.value = true;
            isCookieYesCompleted.value = true;
            return;
          }
        }
      }
      if (!window.cookieyes) {
        console.log('偵測到此環境未綁定 CookieYes 服務，自動開啟所有權限。');
        isCookieYesConsent.value = true;
      }
      isCookieYesCompleted.value = true;
    }, 3000);
  };

  const CONSET_COOKIE_YES = (): void => {
    /**
     * 設定已同意 CookieYes
     */
    if (typeof window.performBannerAction === 'function') {
      window.performBannerAction('accept_all');
    }
    isCookieYesConsent.value = true;
    isCookieYesCompleted.value = true;
  };

  return {
    isCookieYesConsent,
    isCookieYesCompleted,
    HANDLE_COOKIE_YES_LOAD,
    HANDLE_COOKIE_YES_UPDATE,
    SET_COOKIE_YES_COMPLETE,
    CONSET_COOKIE_YES,
  };
});
